/** Patterns for `useWebHaptics().trigger()` */

export const HAPTIC_SUCCESS = [
  { duration: 30 },
  { delay: 60, duration: 40, intensity: 1 },
] as const;

export const HAPTIC_WARNING = [
  { duration: 40, intensity: 0.8 },
  { delay: 100, duration: 40, intensity: 0.6 },
] as const;

export const HAPTIC_ERROR = [
  { duration: 40, intensity: 0.7 },
  { delay: 40, duration: 40, intensity: 0.7 },
  { delay: 40, duration: 40, intensity: 0.9 },
  { delay: 40, duration: 50, intensity: 0.6 },
] as const;

/** Short tap for in-story prev/next */
export const HAPTIC_LIGHT_NAV = [{ duration: 22, intensity: 0.88 }] as const;
